module.exports = __webpack_public_path__ + "static/media/image2.f1292e67.jpg";